<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="cover" id="cvi">
<div class="cover">
<p class="fig"><img alt="" role="doc-cover" src="images/chi-Prager-cover.jpg"/></p>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-prager-0001.vue?8e48b73a